"use client"

import Link from "next/link"
import { Button } from "@/components/ui/button"
import { useTranslation } from "react-i18next"

export function AuthButtonsClient() {
  const { t } = useTranslation()

  return (
    <div className="flex items-center rounded-full border border-orange-200 bg-white p-1 shadow-sm">
      <Link href={"/account/sign-in"}>
        <Button className="h-9 rounded-full border border-transparent bg-transparent px-4 text-sm font-semibold text-slate-700 hover:bg-orange-50 hover:text-orange-700">
          {t("signIn.loginButton")}
        </Button>
      </Link>
      <Link href={"/account/sign-up"}>
        <Button className="h-9 rounded-full border-0 bg-gradient-to-r from-orange-500 via-orange-400 to-amber-400 px-4 text-sm font-semibold text-white shadow-[0_8px_18px_-12px_rgba(234,88,12,0.8)] transition-all duration-200 hover:from-orange-600 hover:via-orange-500 hover:to-amber-500">
          {t("signIn.registerButton")}
        </Button>
      </Link>
    </div>
  )
}
